import * as RadioPrimitive from '@radix-ui/react-radio-group';
import { useId } from 'react';

export function RadioGroup({ label, value, onChange, options, disabled }: {
  label: string; value: string; onChange: (value: string) => void;
  options: { value: string; label: string }[]; disabled?: boolean;
}) {
  const id = useId();
  return <div className="space-y-3">
    <div id={id} className="text-sm font-semibold text-gray-700">{label}</div>
    <RadioPrimitive.Root aria-labelledby={id} value={value} onValueChange={onChange} disabled={disabled} orientation="horizontal" className="flex flex-wrap items-center gap-x-6 gap-y-3">
      {options.map((option, index) => <label key={option.value} htmlFor={`${id}-${index}`} className="flex cursor-pointer items-center gap-2 text-sm text-gray-700">
        <RadioPrimitive.Item id={`${id}-${index}`} value={option.value} className="flex h-4 w-4 items-center justify-center rounded-full border border-gray-300 bg-white text-primary outline-none focus-visible:ring-2 focus-visible:ring-primary/30 data-[state=checked]:border-primary disabled:cursor-not-allowed disabled:opacity-50">
          <RadioPrimitive.Indicator className="h-2 w-2 rounded-full bg-primary" />
        </RadioPrimitive.Item>{option.label}
      </label>)}
    </RadioPrimitive.Root>
  </div>;
}
